module.exports = __webpack_public_path__ + "static/img/IMG-Potable_water_System_400_300.6f93f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG-Potable_water_System_400_300.jpg
// module id = QNsh
// module chunks = 7